import { toast } from "sonner";
import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateAnnouncementMutation } from "../api/queries";
import { AnnouncementForm } from "../ui/AnnouncementForm";

export function AnnouncementCreatePage() {
  const nav = useNavigate({ from: "/app/announcements/create" });
  const createAnnouncement = useCreateAnnouncementMutation();

  const defaultPublish = new Date();
  defaultPublish.setMinutes(0, 0, 0);

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ຂ່າວສານ",
              to: "/app/announcements",
            },
            {
              label: "ສ້າງຂ່າວສານ",
            },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-6 flex flex-wrap items-center justify-between gap-2">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">ສ້າງຂ່າວສານ</h2>
            <p className="text-muted-foreground">
              ຕັ້ງຄ່າຂ່າວສານແຈ້ງລູກຄ້າໃນແອັບ
            </p>
          </div>
        </div>

        <AnnouncementForm
          defaultValues={{
            title: "",
            summary: null,
            body: "",
            imageUrl: null,
            priority: "NORMAL",
            showOnOpen: false,
            sendPush: false,
            publishAt: defaultPublish.toISOString(),
            expiresAt: null,
            isActive: true,
          }}
          onSubmit={async (payload) => {
            try {
              const created = await createAnnouncement.mutateAsync(payload);
              toast.success("ສ້າງຂ່າວສານສຳເລັດ");
              nav({
                to: "/app/announcements/$announcementId/edit",
                params: { announcementId: created.id },
              });
            } catch {
              toast.error("ບໍ່ສາມາດສ້າງຂ່າວສານໄດ້");
            }
          }}
          submitting={createAnnouncement.isPending}
          onCancel={() => nav({ to: "/app/announcements" })}
          submitLabel="ບັນທຶກຂ່າວສານ"
        />
      </Main>
    </>
  );
}
